const ITEMS = ["土木工事", "草刈り・環境整備", "伐採工事", "太陽光発電設備工事", "不動産管理・開発事業", "BUILD THE NEXT."];

function Row() {
  return (
    <div className="flex shrink-0 items-center">
      {ITEMS.map((item, i) => (
        <span key={i} className="flex items-center">
          <span className="mx-10 font-display text-2xl font-semibold tracking-[0.2em] text-white/75 md:text-3xl">{item}</span>
          <span className="inline-block h-2 w-2 rotate-45 bg-accent" />
        </span>
      ))}
    </div>
  );
}

export default function Marquee() {
  return (
    <div data-testid="services-marquee" className="overflow-hidden border-y border-line bg-coal py-5">
      <div className="marquee-track flex w-max">
        <Row />
        <Row />
      </div>
    </div>
  );
}
